export function sectionHeaderCount() {

    const blocks = document.querySelectorAll('[data-block-count]');

    blocks.forEach(block => {
        const count = block.querySelectorAll('[data-block-count]').length;
        const index = Array.from(blocks).indexOf(block);
        block.textContent = index < 10 ? `(0${index + 1})` : `(${index + 1})`;
    });

}
